"use strict";
/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeHelpers = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var constants_1 = require("../constants");
var getDateStringMonthDayYear = function (date) {
    return "".concat(date.getMonth() + 1, "/").concat(date.getDay(), "/").concat(date.getFullYear());
};
var getDateWeekDelta = function (numWeeks, startDate) {
    if (numWeeks === void 0) { numWeeks = 0; }
    if (startDate === void 0) { startDate = new Date(); }
    var daysDelta = constants_1.DateTimeConstants.WEEK_DAYS * numWeeks;
    return (0, dayjs_1.default)(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + daysDelta));
};
var getDateDaysDelta = function (numDays, startDate) {
    if (numDays === void 0) { numDays = 0; }
    if (startDate === void 0) { startDate = new Date(); }
    return (0, dayjs_1.default)(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + numDays));
};
var getDateFromStringYearMonthDay = function (date) {
    return new Date(date).toISOString().slice(0, 10);
};
/**
 *
 * @param date
 * returns a string in the following format 8.10.22
 */
var getFormattedDateStringDot = function (date) {
    return "".concat(date.getMonth() + 1, ".").concat(date.getDate() + 1, ".").concat(date.getFullYear().toString().slice(2, 4));
};
var getDateRangeString = function (startDate, endDate) {
    return "".concat((0, dayjs_1.default)(new Date(startDate)).format(constants_1.DateTimeConstants.MM_DD_YY), " \u2014 ").concat((0, dayjs_1.default)(new Date(endDate)).format(constants_1.DateTimeConstants.MM_DD_YY));
};
var getDiffDays = function (startDate, endDate) {
    var diff = Math.abs(new Date(startDate).getTime() - new Date(endDate).getTime());
    return Math.ceil(diff / (1000 * 3600 * 24));
};
var isDiffDaysLessThanOrEQ = function (startDate, endDate, daysThreshold) { return getDiffDays(startDate, endDate) <= daysThreshold; };
exports.DateTimeHelpers = {
    getDateWeekDelta: getDateWeekDelta,
    getDateFromStringYearMonthDay: getDateFromStringYearMonthDay,
    getDateStringMonthDayYear: getDateStringMonthDayYear,
    getDateDaysDelta: getDateDaysDelta,
    getDateRangeString: getDateRangeString,
    getDiffDays: getDiffDays,
    isDiffDaysLessThanOrEQ: isDiffDaysLessThanOrEQ,
    getFormattedDateStringDot: getFormattedDateStringDot,
};
